module.exports = __webpack_public_path__ + "static/img/定制服务.40473b18.png";